// Barra de frete grátis do carrinho (snippets/body-cart-frete.liquid), 04/10/2026.
// A meta depende da região que o cliente consultou na página do produto (localStorage 'body-frete-zona'):
//   rr = cidades da RR (meta menor), ba = resto da Bahia (padrão), fora = fora da Bahia (barra escondida).
// O carrinho é redesenhado pelo Horizon a cada mudança (morph); por isso o conteúdo é recalculado quando
// o atributo data-total muda e também se o morph devolver o texto padrão.
const real = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

class BodyFreteBarra extends HTMLElement {
  static observedAttributes = ['data-total'];

  connectedCallback() {
    this.render();
    this.observador = new MutationObserver(() => this.render());
    this.observador.observe(this, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    this.observador?.disconnect();
  }

  attributeChangedCallback() {
    if (this.isConnected) this.render();
  }

  zona() {
    try { return localStorage.getItem('body-frete-zona') || 'ba'; } catch { return 'ba'; }
  }

  render() {
    const zona = this.zona();
    const total = Number(this.dataset.total || 0) / 100;
    const limite = Number(zona === 'rr' ? this.dataset.rr : this.dataset.ba);
    if (zona === 'fora' || !limite) { this.hidden = true; return; }
    this.hidden = false;
    const onde = zona === 'rr' ? 'com a RR Transportes' : 'na Bahia';
    const falta = limite - total;
    const texto = falta > 0.005
      ? `Faltam <strong>${real(falta)}</strong> para o frete grátis ${onde}`
      : `Você ganhou <strong>frete grátis</strong> ${onde}`;
    const pct = Math.max(0, Math.min(100, (total / limite) * 100));
    const html = `<p class="bfb__texto">${texto}</p><span class="bfb__trilho" aria-hidden="true"><i style="width: ${pct}%"></i></span>`;
    this.classList.toggle('bfb--ganhou', falta <= 0.005);
    if (this.innerHTML.replace(/\s+/g, ' ').trim() === html) return;
    this.observador?.disconnect();
    this.innerHTML = html;
    this.observador?.observe(this, { childList: true, subtree: true, characterData: true });
  }
}

if (!customElements.get('body-frete-barra')) customElements.define('body-frete-barra', BodyFreteBarra);
